export const data = [
  {
    id: 1,
    imgPath: "z1s0X9z9aHE",
  },
  {
    id: 2,
    imgPath: "TQl9TzZ31WY",
  },
  {
    id: 3,
    imgPath: "jRPHXlvPpcA",
  },
  {
    id: 4,
    imgPath: "YbSi5n2giIM",
  },
  {
    id: 5,
    imgPath: "aOEVKLrg5vI",
  },
  {
    id: 6,
    imgPath: "2w5YXocI0AY",
  },
  {
    id: 7,
    imgPath: "M8OW5sRW-JA",
  },
  {
    id: 8,
    imgPath: "VtWn7Ntwib4",
  },
  {
    id: 9,
    imgPath: "bn-IUoD81iU",
  },
  {
    id: 10,
    imgPath: "knx64QBP7m8",
  },
  {
    id: 11,
    imgPath: "ELyv87WQFDc",
  },
  {
    id: 12,
    imgPath: "9tn3NKppVsY",
  },
  {
    id: 13,
    imgPath: "bfsRk6-CFYo",
  },
  {
    id: 14,
    imgPath: "s-yL3a1Oti8",
  },
  {
    id: 15,
    imgPath: "nv3W5tF-V1E",
  },
  {
    id: 16,
    imgPath: "uNKUcEwhmrk",
  },
  {
    id: 17,
    imgPath: "HOL_JdJLJeU",
  },
  {
    id: 18,
    imgPath: "K7tcHICu-qY",
  },
  {
    id: 19,
    imgPath: "mTPrnBSl1iY",
  },
  {
    id: 20,
    imgPath: "DLFFXt_h4Cg",
  },
  {
    id: 21,
    imgPath: "h4OegiGo6bQ",
  },
  {
    id: 22,
    imgPath: "d7tnuawEJOg",
  },
  {
    id: 23,
    imgPath: "7CmOPhtn88M",
  },

  {
    id: 25,
    imgPath: "NBHKoxorEVM",
  },
  {
    id: 26,
    imgPath: "5zmoQ7zgE08",
  },
  {
    id: 27,
    imgPath: "-i-w1j2J6hc",
  },
  {
    id: 28,
    imgPath: "9ANX0-Oo4i0",
  },
  {
    id: 29,
    imgPath: "QXEnC3W5JJA",
  },
  {
    id: 30,
    imgPath: "ZLY6aRSolBM",
  },
  {
    id: 31,
    imgPath: "6nXvmqQHhFo",
  },
  {
    id: 32,
    imgPath: "QUC1j5NTXNk",
  },
  {
    id: 33,
    imgPath: "ipPxWwZ_1Ck",
  },
  {
    id: 34,
    imgPath: "YJeYNLh_kTg",
  },
  {
    id: 35,
    imgPath: "P5fRzeqqOO4",
  },
  {
    id: 36,
    imgPath: "f4A0cuyPQqs",
  },
];
